import * as ko from 'knockout';

interface KnockoutBindingHandlers {
	element: KnockoutBindingHandler;
}
((ko: KnockoutStatic) => {
	ko.bindingHandlers.element = {
		init: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
			// First get the latest data that we're bound to
			var value = valueAccessor();
			if (ko.isObservable(value)) {
				value(element);
			}
		}
	};
})(ko);
